<template>
<div>
    <div id="fangwen" style="width:98%;min-height:400px;"></div>
</div>
</template>

<script>
// import Spin from 'iview/src/component/spin.vue'
import echarts from 'echarts/lib/echarts.js'
import 'echarts/lib/chart/bar'
// import 'echarts/lib/chart/line'
// import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/dataZoom'
// import 'echarts/lib/component/axisPointer'

export default {
    name: 'service-fangwen-echarts',
    props: ['dataInfo'],
    computed: {
        echartsData() {
            try {
                const Vm = this
                let xAxis = {}
                let yAxis = {}
                xAxis.data = Vm.dataInfo.map((item) => {
                    if (item.serviceName) {
                        return item.serviceName
                    }
                })
                yAxis.data = Vm.dataInfo.map((item) => {
                    if (item.count) {
                        return item.count
                    }
                })
                // console.log(xAxis.data)
                // console.log(yAxis.data)
                return {
                    xAxis: xAxis,
                    yAxis: yAxis
                }
            } catch (Error) {
                // console.log(Error)
                return []
            }
        }
    },
    data() {
        return {
            mycharts: null
        }
    },
    watch: {
        echartsData() {
            const Vm = this
            Vm.initEcharts()
        }
    },
    mounted() {
        let Vm = this
        Vm.myCharts = echarts.init(document.getElementById('fangwen'))
        Vm.initEcharts()
        window.onresize = () => {
            Vm.myCharts.resize()
        }
    },
    methods: {
        initEcharts() {
            const Vm = this
            try {
                Vm.myCharts.setOption({
                    legend: {},
                   
                    tooltip: {
                        show: false,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow',
                        },
                    },
                    grid: {
                        left: '2%',
                        right: '3%',
                        bottom: '3%',
                        top: '10%',
                        containLabel: true,
                    },
                    // splitLine:{ 
                    //     show: true, 
                    //     lineStyle:{ 
                    //         type: 'dashed'
                    //     }
                    // },
                    xAxis: {
                        // show: false,
                        // type: 'value',
                        type : 'category',
                        // boundaryGap: [0, 0.01],
                        axisLabel: {
                            interval:0,
                            rotate: 40,
                        },
                        // axisTick: {
                        //     show: false
                        // },
                        // axisLine: {
                        //     show: true
                        // },
                        // position: 'bottom',
                        data: Vm.echartsData.xAxis.data,
                    },
                    yAxis: {
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            inside: false,
                        },
                        type : 'value'
                    },
                    series: [
                        {
                            // name: '服务次数',
                            type: 'bar',
                            data: Vm.echartsData.yAxis.data,
                            barWidth : 30,
                            barMinHeight: 10,
                            itemStyle: {
                                normal: {
                                    color: '#3B99FC',
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            fontWeight: 'bolder',
                                            fontSize: '12',
                                            fontFamily: '微软雅黑',
                                        },
                                        // color: '#FFFFFF',
                                    },
                                },
                            },
                        },
                    ]
                })
            } catch (Error) {
                // console.log(Error)
                return
            }
        }
    }
}
</script>

<style>
  
</style>
